import { rgba } from 'polished';

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'inline-block',
    opacity: 0,
    userSelect: 'none'
  },
  frame: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    border: `1px solid ${rgba(theme.color.primary.dark, 0.28)}`,
    backgroundImage: [
      `linear-gradient(to right, ${rgba(theme.color.primary.main, 0.75)} 28px, transparent 28px)`,
      `linear-gradient(to bottom, ${rgba(theme.color.primary.main, 0.75)} 28px, transparent 28px)`,
      `linear-gradient(to left, ${rgba(theme.color.primary.main, 0.75)} 28px, transparent 28px)`,
      `linear-gradient(to bottom, ${rgba(theme.color.primary.main, 0.75)} 28px, transparent 28px)`,
      `linear-gradient(to right, ${rgba(theme.color.primary.main, 0.75)} 28px, transparent 28px)`,
      `linear-gradient(to top, ${rgba(theme.color.primary.main, 0.75)} 28px, transparent 28px)`,
      `linear-gradient(to left, ${rgba(theme.color.primary.main, 0.75)} 28px, transparent 28px)`,
      `linear-gradient(to top, ${rgba(theme.color.primary.main, 0.75)} 28px, transparent 28px)`
    ].join(','),
    backgroundPosition: [
      'left top',
      'left top',
      'right top',
      'right top',
      'left bottom',
      'left bottom',
      'right bottom',
      'right bottom'
    ].join(','),
    backgroundSize: [
      '44px 1px',
      '1px 44px',
      '44px 1px',
      '1px 44px',
      '44px 1px',
      '1px 44px',
      '44px 1px',
      '1px 44px'
    ].join(','),
    backgroundRepeat: 'no-repeat',
    boxShadow: `0 0 18px ${rgba(theme.color.secondary.dark, 0.08)}`
  },
  main: {
    position: 'relative',
    padding: 20
  },
  message: {
    marginBottom: 20,
    color: theme.color.text.main,
    textAlign: 'center'
  },
  options: {
    textAlign: 'center'
  },
  option: {
    display: 'inline-block'
  },

  '@media screen and (min-width: 480px)': {
    main: {
      position: 'relative',
      padding: [20, 40]
    }
  }
});

export { styles };

// Commit trace: 2026-02-02T04:50:45 - refactor: reorganize imports in Popup.styles.js
